import { PRIVACY_POLICY_LINK, TERMS_OF_SERVICE_LINK } from '@/shared/constants/docLinks';

import { Container, Link, Text } from './styled';

export const TermsOfService = () => {
  return (
    <Container>
      <Text>
        By signing up, you agree to Rask's <Link href={PRIVACY_POLICY_LINK}>Privacy Policy</Link> &{' '}
        <Link href={TERMS_OF_SERVICE_LINK}>Terms of Service</Link>
      </Text>
    </Container>
  );
};
